import React from "react";
import PageHero from "../components/PageHero";
import Gallery from "../components/Gallery";
import Seo from "../components/Seo";
import AIShowcase from "../components/AIShowcase";
import { MEDIA } from "../data/media";

export default function Portfolio() {
  return (
    <div data-testid="page-portfolio">
      <Seo
        title="Work — Websites, Platforms & AI Studio | AberCal"
        description="Selected work from AberCal: live client websites, custom platforms, and an AI Studio of AI-generated images, animation and video for businesses."
        path="/portfolio"
      />
      <PageHero
        testid="portfolio-hero"
        overline="Selected Work"
        title="Dreams,"
        accent="delivered."
        subtitle="A tartan is many threads woven into one pattern that belongs to a single clan. No two are alike — and neither is the work here."
        bg={MEDIA.forge}
      />
      <Gallery />
      <AIShowcase />
    </div>
  );
}
